import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CardHeader } from '../ui/CardHeader';
import { MeterBar } from '../ui/MeterBar';
import { StatTile } from '../ui/StatTile';
import { SurfaceCard } from '../ui/SurfaceCard';
import type { WeatherView } from '../../weather/format';

interface SensorCardProps {
  view: WeatherView;
  onOpenHistory: () => void;
}

export function SensorCard({ view, onOpenHistory }: SensorCardProps) {
  return (
    <SurfaceCard>
      <CardHeader title="Stare senzor" onOpenHistory={onOpenHistory} />

      <Typography
        sx={(theme) => ({ fontSize: 13, color: theme.palette.weather.soft, marginTop: '-8px' })}
      >
        {view.statusNote} · {view.lastSeenAgo}
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: '12px',
        }}
      >
        <StatTile label="Baterie" value={view.battery}>
          <MeterBar width={view.batteryWidth} />
        </StatTile>
        <StatTile label="Semnal" value={view.linkquality}>
          <MeterBar width={view.linkWidth} />
        </StatTile>
        <StatTile label="Condensator" value={view.capacitorVoltage} />
        <StatTile label="Alimentare" value={view.voltage} />
      </Box>
    </SurfaceCard>
  );
}
